import React, { Component, useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Moment from 'moment';
import SignatureCanvas from "react-signature-canvas";
import MuiAlert from "@material-ui/lab/Alert";
import Axios from "axios";
import alert from '../alert.png'

import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import PropTypes from 'prop-types';
import './style1.css';
import axios from 'axios';
import './style.scss';
import user from '../user.svg';
import bank from '../mansabank.png';
import { Input } from '@material-ui/core';
import { Label } from 'reactstrap';
import Bottomstrip from './Bottomstrip';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';



const myOptions_ = ['Afghanistan-AFG','African Reinsurance Sorpo-ARC', 'Albania-ALB', 'Algeria-DZA', 'American Samoa-ASM', 'Andorra-AND', 'Angola-AGO', 'Anguilla-AIA', 'Antarctica-ATA', 'Antigua and Barbuda-ATG', 'Argentina-ARG', 'Armenia-ARM', 'Aruba-ABW', 'Australia-AUS', 'Austria-AUT', 'Azerbaijan-AZE', 'Bahamas (the)-BHS', 'Bahrain-BHR', 'Bangladesh-BGD', 'Barbados-BRB', 'Belarus-BLR', 'Belgium-BEL', 'Belize-BLZ', 'Benin-BEN', 'Bermuda-BMU', 'Bhutan-BTN', 'Bolivia (Plurinational State of)-BOL', 'Bonaire, Sint Eustatius and Saba-BES', 'Bosnia and Herzegovina-BIH', 'Botswana-BWA', 'Bouvet Island-BVT', 'Brazil-BRA', 'British Indian Ocean Territory (the)-IOT', 'Brunei Darussalam-BRN', 'Bulgaria-BGR', 'Burkina Faso-BFA', 'Burundi-BDI', 'Cabo Verde-CPV', 'Cambodia-KHM', 'Cameroon-CMR', 'Canada-CAN', 'Cayman Islands (the)-CYM', 'Central African Republic (the)-CAF', 'Chad-TCD', 'Chile-CHL', 'China-CHN', 'Christmas Island-CXR', 'Cocos (Keeling) Islands (the)-CCK', 'Colombia-COL', 'Comoros (the)-COM', 'Congo (the Democratic Republic of the)-COD', 'Congo (the)-COG', 'Cook Islands (the)-COK', 'Costa Rica-CRI', 'Croatia-HRV', 'Cuba-CUB', 'Curaçao-CUW', 'Cyprus-CYP', 'Czechia-CZE', 'Côte d Ivoire-CIV', 'Denmark-DNK', 'Djibouti-DJI', 'Dominica-DMA', 'Dominican Republic (the)-DOM', 'Ecuador-ECU', 'Egypt-EGY', 'El Salvador-SLV', 'Equatorial Guinea-GNQ', 'Eritrea-ERI', 'Estonia-EST', 'Eswatini-SWZ', 'Ethiopia-ETH', 'Falkland Islands (the) [Malvinas]-FLK', 'Faroe Islands (the)-FRO', 'Fiji-FJI', 'Finland-FIN', 'France-FRA', 'French Guiana-GUF', 'French Polynesia-PYF', 'French Southern Territories (the)-ATF', 'Gabon-GAB', 'Gambia (the)-GMB', 'Georgia-GEO', 'Germany-DE', 'Ghana-GHA', 'Gibraltar-GIB', 'Greece-GRC', 'Greenland-GRL', 'Grenada-GRD', 'Guadeloupe-GLP', 'Guam-GUM', 'Guatemala-GTM', 'Guernsey-GGY', 'Guinea-GIN', 'Guinea-Bissau-GNB', 'Guyana-GUY', 'Haiti-HTI', 'Heard Island and McDonald Islands-HMD', 'Holy See (the)-VAT', 'Honduras-HND', 'Hong Kong-HKG', 'Hungary-HUN', 'Iceland-ISL', 'India-IND', 'Indonesia-IDN','Interpol-INP', 'Iran (Islamic Republic of)-IRN', 'Iraq-IRQ', 'Ireland-IRL', 'Isle of Man-ISM', 'Israel-ISR', 'Italy-ITA', 'Jamaica-JAM', 'Japan-JPN', 'Jersey-JEY', 'Jordan-JOR', 'Kazakhstan-KAZ', 'Kenya-KEN', 'Kiribati-KIR', 'Korea (the Democratic Peoples Republic of)-PRK', 'Korea (the Republic of)-KOR','Kosovo-RKS', 'Kuwait-KWT', 'Kyrgyzstan-KGZ', 'Lao Peoples Democratic Republic (the)-LAO', 'Latvia-LVA', 'Lebanon-LBN', 'Lesotho-LSO', 'Liberia-LBR', 'Libya-LBY', 'Liechtenstein-LIE', 'Lithuania-LTU', 'Luxembourg-LUX', 'Macao-MAC', 'Madagascar-MDG', 'Malawi-MWI', 'Malaysia-MYS', 'Maldives-MDV', 'Mali-MLI', 'Malta-MLT', 'Marshall Islands (the)-MHL', 'Martinique-MTQ', 'Mauritania-MRT', 'Mauritius-MU', 'Mayotte-MYT', 'Mexico-MEX', 'Micronesia (Federated States of)-FSM', 'Moldova (the Republic of)-MDA', 'Monaco-MCO', 'Mongolia-MNG', 'Montenegro-MON', 'Montserrat-MSR','Monrovia-MRV', 'Morocco-MAR','Moscow-MOS', 'Mozambique-MOZ', 'Myanmar-MMR', 'Namibia-NAM', 'Nauru-NRU', 'Nepal-NPL', 'Netherlands (the)-NLD', 'New Caledonia-NCL', 'New Zealand-NZL', 'Nicaragua-NIC', 'Niger (the)-NER', 'Nigeria-NGA', 'Niue-NIU', 'Norfolk Island-NFK', 'Northern Mariana Islands (the)-MNP', 'Norway-NOR', 'Oman-OMN', 'Pakistan-PAK', 'Palau-PLW', 'Palestine, State of-PSE', 'Panama-PAN', 'Papua New Guinea-PNG', 'Paraguay-PRY', 'Peru-PER', 'Philippines (the)-PHL', 'Pitcairn-PCN', 'Poland-POL', 'Portugal-PRT', 'Puerto Rico-PRI', 'Qatar-QAT', 'Reefugee-XXC','Republic of North Macedonia-MKD', 'Romania-ROU', 'Russian Federation (the)-RUS', 'Rwanda-RWA', 'Réunion-REU','Sahara-SAH', 'Saint Barthélemy-BLM', 'Saint Helena, Ascension and Tristan da Cunha-SHN', 'Saint Kitts and Nevis-KNA', 'Saint Lucia-LCA', 'Saint Martin (French part)-MAF', 'Saint Pierre and Miquelon-SPM', 'Saint Vincent and the Grenadines-VCT', 'Samoa-WSM', 'San Marino-SMR', 'Sao Tome and Principe-STP', 'Saudi Arabia-SAU', 'Senegal-SEN', 'Serbia-SRB', 'Seychelles-SYC','Siberia-SIB', 'Sierra Leone-SLE', 'Singapore-SGP', 'Sint Maarten (Dutch part)-SXM', 'Slovakia-SVK', 'Slovenia-SVN', 'Solomon Islands-SLB', 'Somalia-SOM', 'South Africa-ZAF', 'South Georgia and the South Sandwich Islands-SGS', 'South Sudan-SSD', 'Spain-ESP', 'Sri Lanka-LKA', 'Sudan (the)-SDN', 'Suriname-SUR', 'Svalbard and Jan Mayen-SJM', 'Sweden-SWE', 'Switzerland-CHE', 'Syrian Arab Republic-SYR', 'Taiwan (Province of China)-TWN', 'Tajikistan-TJK', 'Tanzania, United Republic of-TZA', 'Thailand-THA', 'Timor-Leste-TLS', 'Togo-TGO', 'Tokelau-TKL', 'Tonga-TON', 'Trinidad and Tobago-TTO', 'Tunisia-TUN', 'Turkey-TUR', 'Turkmenistan-TKM', 'Turks and Caicos Islands (the)-TCA', 'Tuvalu-TUV', 'Uganda-UGA', 'Ukraine-UKR', 'United Arab Emirates (the)-ARE','United Nations-UNA','United Nations-UNO', 'United Kingdom of Great Britain and Northern Ireland (the)-GBR', 'United States Minor Outlying Islands (the)-UMI', 'United States of America (the)-USA', 'Uruguay-URY', 'Uzbekistan-UZB', 'Vanuatu-VUT', 'Venezuela (Bolivarian Republic of)-VEN', 'Viet Nam-VNM', 'Virgin Islands (British)-VGB', 'Virgin Islands (U.S.)-VIR', 'Wallis and Futuna-WLF', 'Western Sahara-ESH', 'Yemen-YEM', 'Zambia-ZMB', 'Zimbabwe-ZWE','Zimbabwe Zim-ZIM', 'Åland Islands-ALA'];

function calculate_age(dob) {
    var diff_ms = Date.now() - dob.getTime();
    var age_dt = new Date(diff_ms);
    return parseInt(Math.abs(age_dt.getUTCFullYear() - 1970));
}

function updateCustomerMsisdn(msisdn, isNew){
        const axios = require('axios');
            const qs = require('qs');
            let msisdnStr='230'+msisdn;
            let token=localStorage.getItem('Token');
            let data = qs.stringify({
                'token': token,
                'msisdn': msisdnStr,
                'newCustomer': isNew,
                'iccid': '***********'
            });
    
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://ekyc.chili.mu:9443/api/msisdnUpdate',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: data
            };
    
            axios.request(config)
                .then((response) => {
                   console.log(response.data);
    
                })
                .catch((error) => {
                    
                    console.error('error updating msisdn');
                });
    
    }


function sendContigencySms() {


    let txt = "Your e-KYC verification is pending and please perform Re-Registration when system is available for your Token ID is ." + localStorage.getItem('Token');
    const req = Axios.get("https://ekyc.chili.mu:9443/ekyc/v1/sms?msisdn=" + "230" + localStorage.getItem("CustomerNumber") + "&from=2306668&text=" + txt + "&configId=2&locale=en",
        {
            headers: { 'Content-Type': 'application/json; charset=utf-8' }
        }).then((res) => {
            console.log("result is ", res.data.status);


        }).catch((error) => {
            console.log(error);
        });

}

function handleChange() {

}

function setCountryCode(cc){
 let ccStr = cc;
 ccStr = JSON.stringify(ccStr).split('-')[1];
 
 ccStr = ccStr.replaceAll('"','');
 ccStr = ccStr.replaceAll('\\','');
 console.log('***ccStr****', ccStr);
 localStorage.setItem('countryCode', ccStr);
}

const filterOptions = createFilterOptions({
    matchFrom: 'middle',
    stringify: option => option,
});

function Alert(props) {
    return <MuiAlert elevation={6}
        variant="filled" {...props} />;
}


const format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~0123456789]/;
const useStyles = (theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },

    cssLabel: {
        color: '#f049ac',
    },
    input: {
        color: '#f049ac',
    },

    cssOutlinedInput: {
        '&$cssFocused $notchedOutline': {
            borderColor: `${theme.palette.primary.main} !important`,
        },
    },

    cssFocused: {},

    notchedOutline: {
        borderWidth: '1px',
        borderColor: 'Gray !important',
    },
    select: {
        '&:before': {
            borderColor: 'Gray',
        },
        color: '#f049ac',
    },
    icon: {
        fill: 'Gray',
    },
});




let error = false;
let errors = false;
let notfound = false;
let contingency = false;
let errorMsg = false;
let response = localStorage.getItem('errormsg');
    if(response==null)
    {
        errors=false
        console.log("response==>",response)
        console.log("response Error==>",errors)
    }
    else
    {
        errors=true    
        console.log("response==>",response)
        console.log("response Error==>",errors)    
    }

const agentType = localStorage.getItem('agentType');

class Auth extends Component {



    constructor(props) {
        super(props);
        //msg = ;
        
        //console.log('*****',localStorage.getItem('userType'));
        //localStorage.removeItem('croppedId1');
        if (localStorage.getItem('icta-process') == 'error') {
            error = true;
            errorMsg = localStorage.getItem('icta-error');
            //localStorage.setItem('contingency', 'true');
            //contingency = true;
        }
        if (localStorage.getItem('icta-process') == 'retry') {
            notfound = true;
            //sendContigencySms();
            //localStorage.setItem('contingency', 'true');
            //contingency = true;

        }
        if (localStorage.getItem('icta-process') == 'contingency') {
            
            contingency = true;
            

        }


        
        //console.log('icta-process message ', localStorage.getItem('icta-process'));
        // const [id,setid]=useState(localStorage.getItem('IDtype') ) //Getting here Govtid proof
        const token = localStorage.getItem('token');
        const kycdata = localStorage.getItem('kyc-data');
        localStorage.removeItem('icta-process');
        let loggedin = true;
        if (token == null) {
            loggedin = false;
        }
        let ccStr = '';
        if (localStorage.getItem('countryCode') != null && localStorage.getItem('countryCode') != "") {
            ccStr = localStorage.getItem('countryCode').toUpperCase();

        }
        if (localStorage.getItem("userType") == 'citizen') {
            ccStr = 'MAU';
            localStorage.setItem('type', 'SELF')
        }
        if (localStorage.getItem("userType") == "tourist") {
            localStorage.setItem('type', 'TOURIST')
        }

        localStorage.setItem('countryCode', ccStr);
        // let dob = localStorage.getItem('dob');
        // if (localStorage.getItem("userType") == 'resident') {
        //     localStorage.setItem('type', 'RESIDENT')
        //     if (dob != null && dob.length == 6) {
        //         let yy = new String(dob).substring(0, 2);
        //         let mm = new String(dob).substring(2, 4);
        //         let dd = new String(dob).substring(4, 6);
        //         if (yy > 25) {
        //             yy = '19' + yy;
        //         } else { yy = '20' + yy }
        //         dob = dd + '/' + mm + '/' + yy
        //         localStorage.setItem('dob', dob);
        //         console.log('resident dob', dob);
        //         //dob = new Date(dob);
        //         //let dateis = Moment(dob).format('DD/MM/YYYY');
        //         //console.log('converted resident dob',dateis);
        //         //dob = dateis;
        //     }

        // }
        this.state = {
            agentNumber: localStorage.getItem("AgentNumber"),
            uservalue: localStorage.getItem("userType"),
            IDTYPE: localStorage.getItem('IDtype'),
            showform:'yes',
            json_len: -1,
            loggedin,
            cnt: 1,
            cli: 1,
            emsg:'',
            details: {
                firstName: localStorage.getItem('fn'),   //localStorage.getItem('fn'),
                lastName: localStorage.getItem('ln'),    //localStorage.getItem('ln'),
                gender: localStorage.getItem('gender'),
                // date: dob,       //localStorage.getItem('dob'),
                cc: localStorage.getItem('countryCode'),

                nid: localStorage.getItem('id'),
                type: '',
                puid: localStorage.getItem('pmUid'),

                //address: localStorage.getItem('address'),
                //accountType: 'Savings Account',
                //occupation: '',
                //mother: '',
                //place: '',  

            },
        };
        this.hancli = this.hancli.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }



    componentWillMount() {

        // this.setState({ date: date1 });
    }
    onDateChange = (date) => {
        this.setState((prevState) => ({
            details: {
                ...prevState.details,
                date: date
            },
        })
        );
        let d = new Date(date);
        let month = d.getMonth() + 1;
        let year = d.getFullYear();
        let day = d.getDate();

        let dateis = day + "-" + month + "-" + year;
        dateis = Moment(d).format('DD-MM-YYYY');
        // localStorage.setItem("dob", dateis);
        console.log("dob", dateis);
        this.state.details.date = dateis;

    }




    componentDidUpdate() {

        //localStorage.setItem('data', JSON.stringify(this.state));
        //localStorage.setItem('date1', '' + this.state.details.date.getTime());
        //console.log(this.state.details.date);
    }
    mySubmitHandler = (event) => {
        event.preventDefault();
        let nam = this.state.details.firstName;
        let nam2 = this.state.details.lastName;
        // let age = calculate_age(this.state.details.date);
        let cnt = this.state.cnt;

        let check = format.test(nam + nam2);


    };
    hancli() {
        let cli = this.state.cli;
        cli = cli + 1;
        this.setState({ cli: cli });
    }
    handleChange(event) {
        let nam = event.target.name;
        let val = event.target.value;
        this.setState((prevState) => ({
            details: {
                ...prevState.details,
                [nam]: val,
            },
        }));
        console.log('cc', val);
        if (nam == "firstName") {
            localStorage.setItem('fn', val)
        }
        if (nam == "lastName") {
            localStorage.setItem('ln', val)
        }
        if (nam == "gender") {
            localStorage.setItem('gender', val)
        }
        if (nam == "cc") {
            localStorage.setItem('countryCode', val)
        }
        if (nam == "nid") {
            localStorage.setItem('id', val)
        }
        if (nam == "type") {
            localStorage.setItem('type', val)
        }
        if (nam == "puid") {
            localStorage.setItem('puid', val)
        }

        console.log(nam, val);

        // this.setState(prevState=>{
        //     let details = Object.assign({}, prevState.details);
        //     nam = val;
        // })

    };

    submitData() {

        const axios = require('axios');
    
        const qs = require('qs');
     
        let data = qs.stringify({
    
            'countryCode': localStorage.getItem('countryCode'),
    
            // 'dob': '',
    
            'firstName': localStorage.getItem('fn'),
    
            'gender': localStorage.getItem('gender'),
    
            'id': localStorage.getItem('id'),
    
            'lastName': localStorage.getItem('ln'),
    
            'token': localStorage.getItem('Token'),
    
            'passportDateIssued': '',
    
            'passportDateExpired': '',
    
            'passportDateFrom': '',
    
            'passportDateTo': ''
    
        });
     
        console.log("Request===>>", data);
     
        let config = {
    
            method: 'put',
    
            maxBodyLength: Infinity,
    
            url: 'https://ekyc.chili.mu:9443/api/processID',
    
            headers: {
    
                'Content-Type': 'application/x-www-form-urlencoded'
    
            },
    
            data: data
    
        };
     
        axios.request(config)
    
            .then((response) => {
    
                console.log(JSON.stringify(response.data));
    
                let result = response.data.data;
    
                localStorage.setItem("KYCresult", result);
                localStorage.removeItem('errormsg')
     
                if (localStorage.getItem("userType") === 'tourist'|| localStorage.getItem("userType") === 'resident') {
    
                    window.location.replace("/permit");
    
                } else {
    
                    window.location.replace('/address');
    
                }
    
            })
    
            .catch((error) => {    
                console.error("API Error:", error);     
                let errorMsgs = error?.response?.data?.data || "Something went wrong!";
                localStorage.setItem("errormsg", errorMsgs);
                // window.location.reload()
                
                
                
            });    
    }
    
     
    render() {
        // console.log(this.state.age);
        if (this.state.loggedin === false) {
            return <Redirect to="/"></Redirect>;
        }
        const { classes } = this.props;
        return (
            <React.Fragment>
                {errors==true && (
                    <div style={{ marginTop: -20, marginLeft: 90 }}>
                        <Alert severity="error">{localStorage.getItem('errormsg')}</Alert>
                    </div>
                )}
                {notfound && (
                    <div style={{ marginTop: -20, marginLeft: 90 }}>
                        <Alert severity="error">Verification Failed - Record Not Found.</Alert>
                    </div>
                )}
                {contingency && (
                    <div style={{ marginTop: -20, marginLeft: 90 }}>
                        <Alert severity="warning">ICTA Contingency - Please proceed</Alert>
                    </div>
                )}

                { localStorage.getItem('showForm')!="no"?
                <div className="Auth-container"  >
                    {
                        this.state.agentNumber == null || this.state.agentNumber.trim().length == 0 ?
                            null
                            : <div style={{ marginTop: 20, textAlign: 'center', }}>
                                <label><strong>{agentType} Number:{this.state.agentNumber}</strong></label>
                                <Link to="/logout" style={{ textAlign: 'end', marginLeft: 20, color: 'black' }}>Logout</Link>
                                <br></br>

                            </div>
                    }

                    <h4 style={{ color: '#f049ac' }}>

                        {
                            this.state.agentNumber == null || this.state.agentNumber.trim().length == 0 ?
                                <div>Please fill your Valid & Correct information </div>
                                : <div>Please fill Valid & Correct customer information</div>
                        }
                    </h4>

                    <form onSubmit={this.mySubmitHandler}>

                        <br></br>

                        <div
                            style={{
                                textAlign: 'left',
                                color: 'blue',
                                marginLeft: -5,
                                marginTop: -10,
                                marginBottom: 10,
                            }}
                        >
                            <h6 style={{ backgroundColor: 'gray', color: 'white' }}>
                                PERSONAL DETAILS
                            </h6>
                        </div>
                        {(localStorage.getItem('userType') == 'resident' || localStorage.getItem('userType') == 'tourist') && (
                            <div style={{ textAlign: 'center', marginTop: 10 }}>

                                <Autocomplete
                                    style={{ width: 200 }}
                                    freeSolo
                                    filterOptions={filterOptions}
                                    onChange={(event, value) => setCountryCode(value)} 
                                    options={myOptions_}
                                    renderInput={(params) => (
                                        <TextField {...params}
                                            variant="outlined"                                            
                                            id="outlined-required"
                                            name="cc"
                                            value={this.state.details.cc}
                                            label={<div style={{ color: 'black' }}>Choose Country</div>}
                                        />
                                    )}
                                />
                            </div>

                        )}

                        {localStorage.getItem('userType') == 'citizen' && (
                             <div style={{marginTop: 10 }}>
                            <TextField
                                // required
                                name="cc"
                                id="outlined-required"
                                label={<div style={{ color: 'black' }}>Nationality</div>}
                                InputLabelProps={{
                                    classes: {
                                        root: classes.cssLabel,
                                        focused: classes.cssFocused,
                                    },
                                }}
                                InputProps={{
                                    classes: {
                                        input: classes.input,
                                        root: classes.cssOutlinedInput,
                                        focused: classes.cssFocused,
                                        notchedOutline: classes.notchedOutline,
                                    },
                                }}
                                variant="outlined"
                                onChange={(e) => this.handleChange(e)}
                                value={this.state.details.cc}
                            />
                            </div>
                        )}

                        <br></br>
                        <br></br>
                        <TextField
                            // required
                            name="nid"
                            id="outlined-required"
                            label={<div style={{ color: 'black' }}> NID/Passport Number</div>}
                            InputLabelProps={{
                                classes: {
                                    root: classes.cssLabel,
                                    focused: classes.cssFocused,
                                },
                            }}
                            InputProps={{
                                classes: {
                                    input: classes.input,
                                    root: classes.cssOutlinedInput,
                                    focused: classes.cssFocused,
                                    notchedOutline: classes.notchedOutline,
                                },
                            }}
                            variant="outlined"
                            onChange={(e) => this.handleChange(e)}
                            value={this.state.details.nid}
                        />



                        <br></br>
                        <br></br>
                        <TextField
                            // required
                            name="firstName"
                            id="outlined-required"
                            label={<div style={{ color: 'black' }}> First Name</div>}
                            InputLabelProps={{
                                classes: {
                                    root: classes.cssLabel,
                                    focused: classes.cssFocused,
                                },
                            }}
                            InputProps={{
                                classes: {
                                    input: classes.input,
                                    root: classes.cssOutlinedInput,
                                    focused: classes.cssFocused,
                                    notchedOutline: classes.notchedOutline,
                                },
                            }}
                            variant="outlined"
                            onChange={(e) => this.handleChange(e)}
                            value={this.state.details.firstName}
                        />



                        <br></br>
                        <br></br><TextField
                            // required
                            name="lastName"
                            id="outlined-required"
                            label={<div style={{ color: 'black' }}> Last Name</div>}
                            InputLabelProps={{
                                classes: {
                                    root: classes.cssLabel,
                                    focused: classes.cssFocused,
                                },
                            }}
                            InputProps={{
                                classes: {
                                    input: classes.input,
                                    root: classes.cssOutlinedInput,
                                    focused: classes.cssFocused,
                                    notchedOutline: classes.notchedOutline,
                                },
                            }}
                            variant="outlined"
                            onChange={(e) => this.handleChange(e)}
                            value={this.state.details.lastName}
                        />



                        <br></br>
                        <br></br>
                        {
                            this.state.uservalue == "other" ?
                                <div>
                                    <TextField
                                        // required
                                        name="puid"
                                        id="outlined-required"
                                        label={<div style={{ color: 'black' }}>Permit-ID</div>}
                                        InputLabelProps={{
                                            classes: {
                                                root: classes.cssLabel,
                                                focused: classes.cssFocused,
                                            },
                                        }}
                                        InputProps={{
                                            classes: {
                                                input: classes.input,
                                                root: classes.cssOutlinedInput,
                                                focused: classes.cssFocused,
                                                notchedOutline: classes.notchedOutline,
                                            },
                                        }}
                                        variant="outlined"
                                        onChange={(e) => this.handleChange(e)}
                                        value={this.state.details.puid}
                                    />

                                </div>
                                : null
                        }
                        <FormControl
                            className={classes.formControl}
                            style={{ width: 180, marginLeft: 0 }}
                        >
                            <InputLabel
                                id="demo-simple-select-label"
                                style={{ color: 'Gray' }}
                            >
                                Gender
                            </InputLabel>
                            <Select
                                name="gender"
                                style={{ textAlign: 'left' }}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={this.state.details.gender}
                                onChange={(e) => this.handleChange(e)}
                                className={classes.select}
                                inputProps={{
                                    classes: {
                                        icon: classes.icon,
                                    },
                                }}
                            >
                                <MenuItem value="N">Choose</MenuItem>
                                <MenuItem value="F">Female</MenuItem>
                                <MenuItem value="M">Male</MenuItem>
                            </Select>
                        </FormControl>
                        <br></br>
                        <br></br>

                        {/* <MuiThemeProvider theme={customTheme}> */}
                        {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                clearable
                                name="date"
                                value={this.state.details.date}
                                style={{ width: 180, marginLeft: 0 }}
                                placeholder="Date of birth"
                                onChange={this.onDateChange}
                                maxDate={new Date()}
                                format="dd/MM/yyyy"
                                InputProps={{
                                    classes: { input: classes.input },
                                }}
                            />
                        </MuiPickersUtilsProvider> */}
                        {/* </MuiThemeProvider> */}
                        <br />
                        <br />
                        {/* <FormControl
                            className={classes.formControl}
                            style={{ width: 250, marginLeft: 0 }}
                        >
                            <InputLabel
                                id="demo-simple-select-label"
                                style={{ color: 'Gray' }}
                            >
                                User Type
                            </InputLabel>
                            {
                        //     this.state.uservalue == "citizen"?
                        //     <Select
                        //     name="type"
                        //     style={{textAlign:'left'}}
                        //     labelId="demo-simple-select-label"
                        //     id="demo-simple-select"
                        //     value={this.state.details.type}
                        //     onChange={(e) => this.handleChange(e)}
                        //     className={classes.select}
                        //     inputProps={{
                        //         classes: {
                        //             icon: classes.icon,
                        //         },
                        //     }}
                        // >
                        //     <MenuItem value="SELF">Self</MenuItem>
                        //     <MenuItem value="GUARDIAN">Guardian</MenuItem>
                        //     <MenuItem value="ORGANIZATION">Organization</MenuItem>
                        // </Select>
                        
                        this.state.uservalue =="resident"?
                        <Select
                        name="type"
                        style={{textAlign:'left'}}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={this.state.details.type}
                        onChange={(e) => this.handleChange(e)}
                        className={classes.select}
                        inputProps={{
                            classes: {
                                icon: classes.icon,
                            },
                        }}
                    >
                        <MenuItem value="RESIDENT">Resident</MenuItem>
                    </Select>
                            :this.state.uservalue =="tourist"?
                            <Select
                            name="type"
                            style={{textAlign:'left'}}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={this.state.details.type}
                            onChange={(e) => this.handleChange(e)}
                            className={classes.select}
                            inputProps={{
                                classes: {
                                    icon: classes.icon,
                                },
                            }}
                        >
                            <MenuItem value="TOURIST">Tourist</MenuItem>
                            
                        </Select>
                        
                        
                        :null}
                            
                        </FormControl> */}
                        <br></br>
                        <br></br>
                        <button
                                className="button"
                                onClick={this.mySubmitHandler}
                                style={{
                                    marginLeft: 0,
                                    width: 150,
                                    textAlign: 'center',
                                    fontSize: 15,
                                }}
                            > 
                                <Link
                                   
                                    className="link1"
                                    onClick={this.submitData}
                                

                                >
                                    Verify
                                </Link>

                            </button>

                        {/*                         
                        <br></br>
                        <h6 style={{ backgroundColor: 'gray', color: 'white' }}>
                            Please sign below
                        </h6>
                        <div className="app">
                            <SignatureCanvas
                                penColor="blue"
                                canvasProps={{ width: 300, height: 100 }}
                            />
                        </div> */}

                        {/* {!contingency && (this.state.uservalue == "resident" || this.state.uservalue == "tourist")  ? (
                            
                            <button
                                className="button"
                                onClick={this.mySubmitHandler}
                                style={{
                                    marginLeft: 0,
                                    width: 150,
                                    textAlign: 'center',
                                    fontSize: 15,
                                }}
                            > 
                                <Link
                                    to="/passport"
                                    className="link1"
                                    onClick={this.mySubmitHandler}
                                //</button>onClick={
                                //callSimApis()
                                //}

                                >
                                    Verify
                                </Link>

                            </button>
                            ) 
                            :
                            <div>
                                {localStorage.getItem('NewUser')=='yes' && contingency ?
                                null
                                :<button
                                className="button"
                                onClick={this.mySubmitHandler}
                                style={{
                                    marginLeft: 0,
                                    width: 150,
                                    textAlign: 'center',
                                    fontSize: 15,
                                }}
                            >
                                {this.state.IDTYPE == "Passport"  ?
                                    <Link
                                        to="/passport"
                                        className="link1"
                                    //</button>onClick={
                                    //callSimApis()
                                    //}

                                    >
                                        Verify
                                    </Link>
                                    :
                                    <Link
                                        to="/sim"
                                        className="link1"
                                    //</button>onClick={
                                    //callSimApis()
                                    //}

                                    >
                                        Verify
                                    </Link>
                                    }


                            </button>
                                }
                            

                            </div>


                        } */}


 { (this.state.uservalue=='tourist')  && contingency &&(
                     <div>
                            {localStorage.getItem('NewUser')=='yes' ?
                            <button
                            className="button"
                            onClick={this.mySubmitHandler}
                            style={{
                                marginLeft: 0,
                                width: 150,
                                textAlign: 'center',
                                fontSize: 15,
                            }}
                            >
                        
                        <Link to="/uiddetails"  className="link1">
                            Proceed
                            </Link>
                   
                     
                    </button>
                        :null
                        }
                                

                    </div>  
    )}                       

{ (this.state.uservalue=='resident')  && contingency &&( 
                        <div>
                                {localStorage.getItem('NewUser')=='yes' ?
                                    <button
                                            className="button"
                                            onClick={this.mySubmitHandler}
                                            style={{
                                                marginLeft: 0,
                                                width: 150,
                                                textAlign: 'center',
                                                fontSize: 15,
                                            }}
                                            >
                                        
                                        <Link to="/uiddetails"  className="link1"> Proceed </Link>
                                </button>
                            :null
                                }
         

</div> 
                        
                        )}
                         
                         {     (this.state.uservalue=='citizen')  && contingency &&( 
                        <div>
                                {localStorage.getItem('NewUser')=='yes' ?
                                    <button
                                            className="button"
                                            onClick={this.mySubmitHandler}
                                            style={{
                                                marginLeft: 0,
                                                width: 150,
                                                textAlign: 'center',
                                                fontSize: 15,
                                            }}
                                            >
                                        
                                        <Link to="/uiddetails"  className="link1"> Proceed </Link>
                                </button>
                            :null
                                }
         

</div> 
                        
                        )}  

                    </form>

                </div>
                :<div className="Auth-container" style={{textAlign:'center'}}><img
                src={alert}
                style={{
                    height: 200,
                    marginTop: 100,
                }}
                alt="logoo"></img>
                <br></br>
                <br></br>
                <h4 style={{color: '#f049ac'}} > ICTA Error...!</h4>
                        <h6 style={{color:'Gray'}}>Please Logout and Retry after Sometime</h6>
                
                
                </div>}
                


            </React.Fragment>
        );
    }
}
Auth.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(useStyles)(Auth);